import dynamic from 'next/dynamic';

import { FeatureFlags } from 'featureFlags/constants';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { useOffersContext } from 'productTemplate/hooks/useOffersContext';

const PlaceOfferModal = dynamic(
  () =>
    import('productTemplate/components/windows/PlaceOfferModal').then((mod) => mod.PlaceOfferModal),
  {
    ssr: false,
  },
);

const DeprecatedPlaceOfferModal = dynamic(
  () =>
    import('productTemplate/components/windows/DeprecatedPlaceOfferModal').then(
      (mod) => mod.DeprecatedPlaceOfferModal,
    ),
  { ssr: false },
);

const SnackbarNotification = dynamic(
  () => import('shared/components/SnackbarNotification').then((mod) => mod.SnackbarNotification),
  {
    ssr: false,
  },
);

export const ProductDetailPageMobileOffersModal = () => {
  const {
    isPlaceOfferModalShowing,
    setIsSnackbarVisible,
    isSnackbarVisible: isOfferSnackbarVisible,
    snackbarMessage,
  } = useOffersContext();
  const isOfferModalUpdatesEnabled = useFeatureFlag(
    FeatureFlags.TEMP_WEB_ENABLE_OFFER_MODAL_UPDATES,
  );

  return (
    <>
      {isPlaceOfferModalShowing &&
        (isOfferModalUpdatesEnabled ? <PlaceOfferModal /> : <DeprecatedPlaceOfferModal />)}
      {isOfferSnackbarVisible && (
        <SnackbarNotification
          setIsNotificationVisible={setIsSnackbarVisible}
          isNotificationVisible={isOfferSnackbarVisible}
        >
          {snackbarMessage}
        </SnackbarNotification>
      )}
    </>
  );
};
